import { Fragment, useCallback, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSetPageActionContext } from 'src/shared/layout/page-layout/page-layout.context-provider';
import DownloadIcon from '@mui/icons-material/Download';
import { Snackbar } from 'src/shared/snackbar/snackbar';
import { Button } from 'src/shared/button/button';
import {
  useDownloadInvoiceV2PdfMutation,
  useGetInvoiceV2Query,
} from '@service/invoice-v2.service';
import { InvoiceStatus } from '@delmonicos/shared-sdk/libs/emsp/src/libs/invoices-service-lib/src/wrapper/enums/invoice-status.enum';

export function InvoicePreview(): React.JSX.Element {
  const { invoiceId } = useParams();
  const { t } = useTranslation();
  const [error, setError] = useState();
  const [getInvoicePdf] = useDownloadInvoiceV2PdfMutation();
  const { data: invoice } = useGetInvoiceV2Query(invoiceId!, {
    skip: !invoiceId,
  });

  const setPageAction = useSetPageActionContext();

  // HANDLERS //////////////////////////////////////////////////////////////////
  const handleDownloadInvoice = useCallback(async () => {
    if (!invoiceId) {
      return;
    }

    try {
      const data = await getInvoicePdf(invoiceId).unwrap();

      const url = URL.createObjectURL(data);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${invoiceId}.pdf`;
      document.body.appendChild(a);
      a.click();

      a.remove();
      URL.revokeObjectURL(url);
    } catch (err: any) {
      setError(err);
    }
  }, [invoiceId, getInvoicePdf]);

  // RENDER ////////////////////////////////////////////////////////////////////

  useLayoutEffect(() => {
    if (!invoiceId) {
      return;
    }

    const downloadInvoiceButton = (
      <Fragment key="download-invoice">
        <Button
          onClick={handleDownloadInvoice}
          variant="contained"
          disabled={invoice?.status === InvoiceStatus.DRAFT}>
          <DownloadIcon />
          {t('invoice-v2.preview.download-button')}
        </Button>

        {!!error && (
          <Snackbar
            variant="error"
            message={t('error.download-invoice-pdf-mutation', {
              error,
            })}
          />
        )}
      </Fragment>
    );

    setPageAction([downloadInvoiceButton]);
  }, [t, invoiceId, setPageAction, error, handleDownloadInvoice, invoice]);

  return <div />;

  // const { data: invoiceHtml, isError: isGetInvoiceHtmlError } =
  //   useGetInvoiceHtmlQuery(invoiceId ?? null, {
  //     skip: !invoiceId,
  //   });
  //
  // if (!invoiceHtml) {
  //   return (
  //     <>
  //       <InvoicePlaceholder isError={isGetInvoiceHtmlError} />
  //       {isGetInvoiceHtmlError && (
  //         <Snackbar
  //           variant="error"
  //           message={t('error.get-invoice-v1-html-query')}
  //         />
  //       )}
  //     </>
  //   );
  // }

  // return (
  //   <iframe
  //     srcDoc={invoiceHtml}
  //     title={t('invoice-v1.preview.title')}
  //     style={{
  //       border: 'none',
  //       width: '100%',
  //       height: 'calc(100% - 72px)',
  //     }}
  //   />
  // );
}
